import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  FAQApiRequest,
  UpdateFAQRequest,
  DeleteFAQRequest,
} from '@/data/payload/api/FAQRequest'
import { FAQPresenter } from '@/app/ui/presenters/FAQPresenter'
import { FAQ } from '@/domain/entities/Faq'
import router from '@/router'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface FAQState {
  faqData: FAQ
  isLoading: boolean
  fields: any
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'FAQ' })
class FAQs extends VuexModule implements FAQState {
  public faqData = new FAQ(true, '')
  public isLoading = true
  public Pages = 0
  public Limit = 10
  public fields: any = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'question', sortable: true },
    { key: 'answer', sortable: false },
    { key: 'isActive', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'actions', sortable: false },
  ]
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
    },
    search: '',
  }

  @Action
  public async getFAQData() {
    this.setLoading(true)
    const presenter = await container.resolve(FAQPresenter)
    presenter
      .loadFAQ(this.paginationParam)
      .then((res: FAQ) => {
        this.setLoading(false)
        this.setBulletinData(res)
        this.setpages(this.paginationParam.paging.page)
        this.setlimit(this.paginationParam.paging.limit)
        //  console.log('data', res)
      })
      .catch((error) => {
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        router.push('/404/index')
        console.error('error', error)
      })
  }

  @Action
  public async postFAQ(params: {
    question: string
    answer: string
    isActive: boolean
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(FAQPresenter)
    presenter
      .postFAQ(
        new FAQApiRequest(params.question, params.answer, params.isActive)
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'FAQ',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getFAQData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async updateFAQ(params: {
    id: number
    question: string
    answer: string
    isActive: boolean
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(FAQPresenter)
    presenter
      .updateFAQ(
        new UpdateFAQRequest(params.question, params.answer, params.isActive),
        params.id
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'FAQ',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getFAQData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async deleteFAQ(params: { ids: any }) {
    this.setLoading(true)
    const presenter = await container.resolve(FAQPresenter)
    presenter
      .deleteFAQ(new DeleteFAQRequest(params.ids))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'FAQ',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getFAQData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Mutation
  private setBulletinData(faq: FAQ) {
    this.faqData = faq
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
  @Mutation
  private setpages(pages: number) {
    this.Pages = pages
  }
  @Mutation
  private setlimit(limit: number) {
    this.Limit = limit
  }
}

export const FAQModule = getModule(FAQs)
